
export const styles = {
    main : {width:10}
}
